import { N70, N100, Y200, Y300 } from '@atlaskit/theme/colors';
/** Maximum value for app rating */
export const TOTAL_STARS = 4;
export const YELLOW_STAR = 'yellowStar';
export const GREY_STAR = 'greyStar';
export const HALF_STAR = 'halfStar';
export const HALF_STAR_GRADIENT_ID = 'amktCommonHalfStar';
export const HALF_STAR_GRADIENT_HOVER_ID = 'amktCommonHalfStarHover';
export const FILL_MAP = {
  [YELLOW_STAR]: {
    fill: "var(--ds-background-warning-bold, ".concat(Y200, ")"),
    fillHover: "var(--ds-surface-overlay-hovered, ".concat(Y300, ")")
  },
  [GREY_STAR]: {
    fill: "var(--ds-icon-accent-gray, ".concat(N70, ")"),
    fillHover: "var(--ds-surface-overlay-hovered, ".concat(N100, ")")
  },
  [HALF_STAR]: {
    fill: "url(#".concat(HALF_STAR_GRADIENT_ID, ")"),
    fillHover: "url(#".concat(HALF_STAR_GRADIENT_HOVER_ID, ")")
  }
};